module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('strong', [_vm._v(_vm._s(_vm.count))]), _vm._v(" " + _vm._s(_vm.$t('general.number-results', {
    count: ''
  })) + "\n    "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeFiltersCount > 0),
      expression: "activeFiltersCount > 0"
    }],
    ref: "resetButton",
    staticClass: "reset-button reset-filter-text",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.reset-filter')) + " "), _c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 1.3
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.activeFiltersCount > 0) ? _c('div', {
    staticClass: "active-filters-list"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.picked-filters')))]), _vm._v(" "), _c('ul', _vm._l((_vm.activeFilters), function(value, filter) {
    return _c('li', [_c('FilterListItem', {
      attrs: {
        "filter": filter,
        "label": value
      },
      on: {
        "click": function($event) {
          _vm.resetSkiSchoolFilter(filter);
          _vm.emit();
        }
      }
    })], 1)
  }), 0)]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41819d43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/SkiSchool/SkiSchoolFilterInfo.vue
// module id = 974
// module chunks = 0